import { Button } from "@/components/ui/button";

export const HeroSection = ({ data, onNext }: any) => {
    return (
        <div className="py-12 px-4 text-center bg-gray-50">
            <h1 className="text-4xl font-bold mb-4">{data.title || "Hero Title"}</h1>
            <p className="text-xl text-gray-600 mb-8">{data.description || "Hero Description"}</p>
            {data.imageUrl && (
                <img src={data.imageUrl} alt="Hero" className="mx-auto rounded-lg shadow-lg max-w-2xl w-full mb-8" />
            )}
            <Button size="lg" onClick={onNext}>
                {data.buttonText || "Get Started"}
            </Button>
        </div>
    );
};
